import React from 'react';

const ZoomContext = React.createContext(1);
const useZoom = () => {
  const zoom = React.useContext(ZoomContext);
  return { zoom, adjustedZoom: Math.max(1, zoom) };
};
export { ZoomContext, useZoom };
